import { observer } from 'mobx-react-lite'
import { Button, type ITooltipProps } from 'shared/ui'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { AddOnCard } from 'pages/settings/ui/AddOnCard/AddOnCard'
import { useAddOnsViewContext } from 'pages/settings/pages/addOns/context/addOnsViewContext'

export const HipaaCompliance = observer(() => {
  const { featureFlagsStore, organizationStore, usersStore } = useEntitiesContext()
  const store = useAddOnsViewContext()

  if (!featureFlagsStore.hipaa_setting_toggle || !usersStore.user?.isAdminOrOwnerRole) return null

  const isActive = organizationStore.isHipaaCompliant

  const tooltipProps: ITooltipProps | undefined = isActive
    ? {
        label: 'To disable this add-on, please reach out to our team.',
        desc: (
          <Button
            text='Contact support'
            typeBtn='link'
            paddingInline={0}
            style={{ paddingBlock: 0 }}
            onClick={store.hipaaComplianceOnContactSupportClick}
          />
        ),
        type: 'description',
        placement: 'top',
        maxWidth: 350,
      }
    : undefined

  return (
    <AddOnCard
      icon='caduceus'
      iconFontSize={24}
      title='HIPAA Compliance'
      price={store.hipaaCompliancePriceText}
      description='Stricter security with end-to-end encryption, mandatory 2FA, and audit logging.'
      isActive={isActive}
      isSwitchDisabled={isActive}
      tooltipProps={tooltipProps}
      actionButtonText={isActive ? 'Go to security' : undefined}
      onSwitchChange={store.openHipaaComplianceModal}
      onSeeDetailsClick={store.openHipaaComplianceModal}
      onActionClick={isActive ? store.hipaaComplianceOnGoToSecurityClick : undefined}
    />
  )
})
